export default "__VITE_ASSET__DMqubejG__"